import React, {useCallback, useContext, useEffect, useRef, useState} from "react"
import RefreshTimer from "../../util/RefreshTimer";
import {ThinClientOverviewContext} from "./context/ThinClientOverviewContext";
import Row from "@meridian/components/row";

import {
    getCurrentDate,
    getNodeId,
    getAssetRefreshInterval,
    getStatusRefreshInterval, getMacWithoutColon, chainWalk,
    checkHealthStatusForDeletion,
} from "../../util/Util";
import Column from "@amzn/meridian/column";
import {FormattedMessage, injectIntl} from "react-intl";
import {
    AUTOMATION_TEXT,
    BLUE_COLOR,
    DEPLOYMENT_STATUS,
    DEPLOYMENT_TYPE,
    FALSE_VALUE,
    HEALTH_STATUS,
    LOADING_FAILED,
    LOADING_STRING,
    ONLINE_OK,
    PRIMARY,
    SBL_ASSET_TYPE,
    SW_STATUS,
    TAKA_CLIENT_LINK_PREFIX,
    TRUE_VALUE,
    MONITORING_STATUS_LOADER_TIMER,
    SBLV2_ASSET_TYPE,
    SBLV2_TEXT,
    AUTOMATION_ASSET_TYPE,
    IOT_AUTOMATION_ONLOGIC_ASSET_TYPE, SBLV3_TEXT,
} from "../../util/Constants";
import Button from "@amzn/meridian/button";
import Menu, {MenuItem} from "@amzn/meridian/menu"
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Text from "@amzn/meridian/text"
import Icon from "@amzn/meridian/icon";
import editTokens from "@amzn/meridian-tokens/base/icon/edit"
import Input from "@amzn/meridian/input";
import Box from "@amzn/meridian/box";
import {
    postUpdatedRemarkToDevice
} from "./network/ThinClientOverviewNetworkAPI";
import Tooltip from "@amzn/meridian/tooltip";
import LoaderView from "../../loader/Loader";
import chevronDownLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-down-large";
import DeleteSingleDeviceModal from "../../commonui/DeleteSingleDeviceModal";
import DisableMonitoringModal from "../../commonui/DisableMonitoringModal";
import Alert from "@amzn/meridian/alert";
import {checkDeviceMonitoringEnabled, getMonitoringStatusDetails} from "../../util/Validations";
import Link from "@amzn/meridian/link";
import exportToken from "@amzn/meridian-tokens/base/icon/export-small";
import {ConditionalWrapping, tooltipWrapper} from "../../util/ConditionalWrapping";
import {getLocalizedMessage} from "../../util/Localization";
import {ConditionalPlaceholder} from "../../util/ConditionalPlaceholder";
import ChangeDeviceUseCaseModal from "../../commonui/ChangeDeviceUseCaseModal";

const ThinClientOverview = ({intl}) => {

    const {viewModel, dispatch} = useContext(ThinClientOverviewContext);
    const [openActionsMenu, setOpenActionsMenu] = useState({});
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openTCUseCaseChangeModal, setOpenTCUseCaseChangeModal] = useState(false);
    const [selected, setSelected] = useState("");
    const actionButtonRefs = useRef([]);
    const [mac, setMac] = useState("")
    const [remark, setRemark] = useState([]);
    const tableEndRef = useRef(null);
    const [editRemark, setEditRemark] = useState(false);

    const onClickActionsButton = useCallback((index) => {
        let _open = {...openActionsMenu};
        _open[index] = true;
        setOpenActionsMenu(_open);
    }, []);
    const onCloseActions = useCallback((index) => {
        let _open = {...openActionsMenu};
        _open[index] = false;
        setOpenActionsMenu(_open)
    }, []);

    useEffect(() => {
        if (!openAddModal) {
            getData()
            const assetInterval = setInterval(() => {
                if (!document.hidden) {
                    getData();
                }
            }, getAssetRefreshInterval());
            const statusInterval = setInterval(() => {
                if (!document.hidden) {
                    getStatusData();
                }
            }, getStatusRefreshInterval());

            return () => {
                clearInterval(assetInterval);
                clearInterval(statusInterval);
            }
        }
    }, [openAddModal]);
    const sortedDeviceList = Object.values(viewModel.thinClientDeviceInformation);
    useEffect(() => {
        actionButtonRefs.current = actionButtonRefs.current.slice(0, viewModel.thinClientDeviceInformation.length);
        if(!editRemark) {
            setRemark(sortedDeviceList.map((value) => {
                return {value: value.remark, close: true}
            }))
        }
    }, [sortedDeviceList]);

    const onSort = (sortDetails) => {
        setEditRemark(false);
        dispatch({
            type: 'SORT_DATA',
            data: {column: sortDetails.sortColumn, direction: sortDetails.sortDirection}
        })
    }
    sortedDeviceList && sortedDeviceList.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1
        }
        return 0
    })

    const scrollToBottom = () => {
        tableEndRef.current.scrollIntoView({behavior: "smooth"})
    }
    const setStatusLoader = (mac, loadingField, loaderVisible) => {
        dispatch({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: loadingField, loaderVisible: loaderVisible}})
    }
    const showStatusLoader = (mac, loadingField) => {
        return chainWalk(() => viewModel.loadingStatusDevices[mac][loadingField], false);
    }
    const onClickDisableMonitoring = (mac) => {
        setMac(mac)
        setOpenAddModal(true)
    }
    const onClickEnableMonitoring = (startTime, reason, mac) => {
        const stateValues = {
            "startTime": startTime,
            "endTime": getCurrentDate().toString(),
            "reason": reason
        }
        setStatusLoader(mac, 'monitoringStatusLoader', true)
        addData(stateValues, mac);
        setTimeout(()=>{
            getData();
            setStatusLoader(mac, 'monitoringStatusLoader', false)
        },MONITORING_STATUS_LOADER_TIMER)
    }
    const onClickRestartApplication = async (mac, useCase) => {
        setOpenAddModal(false)
        dispatch({type: 'DEPLOY_THIN_CLIENT', data: {dispatcher: dispatch, mac: mac, useCase: useCase}});
    }

    const addData = (stateValues, mac) => {
        dispatch({type: 'ADD_DEVICE_DATA', data: {dispatcher: dispatch, stateValues: stateValues, mac: mac}})
    }

    const onClickToggleUsecase = async (device) => {
        // function to make that tc primary and rest all secondary
        setOpenAddModal(false)
        dispatch({type: 'TOGGLE_USECASE', data: {dispatcher: dispatch, mac: device.mac, useCase: device.useCase}});
    };

    const onClickChangeUsecase = async (device) => {
        //function to change the device use case i.e. deploymentGroup
        setSelected(device);
        setOpenTCUseCaseChangeModal(true);
    }

    const handleKeyDown = (index, row, event) => {
        if (event.key === "Enter") {
            onClickConfirmRemark(index, row);
        }
    }
    const onClickConfirmRemark = (index, row) => {
        // function to send the updated remark to post request in db
        const temp = [...remark];
        temp[index] = {...temp[index], close: true};
        setRemark(temp)
        postUpdatedRemarkToDevice(row, remark[index].value).then(r => {
            getData();
        })
    }
    const onClickEditRemark = (index) => {
        setEditRemark(true);
        const temp = [...remark];
        temp[index] = {...temp[index], close: false};
        setRemark(temp)
    }
    const getData = () => {
        setOpenAddModal(false)
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }
    const getStatusData = () => {
        dispatch({type: 'LOAD_STATUS', data: {dispatcher: dispatch, state: viewModel}});
    }
    const handleInputChange = (index, value) => {
        const temp = [...remark];
        temp[index] = {...temp[index], value: value};
        setRemark(temp)
    }

    const getDeviceHealthStatus = ({connection, healthStatus, useCase}) => {
        if (connection && connection.toLowerCase() === ONLINE_OK) {
            return HEALTH_STATUS.HEALTHY;
        } else if (connection === LOADING_STRING) {
            return HEALTH_STATUS.LOADING;
        } else if (connection === LOADING_FAILED) {
            return HEALTH_STATUS.LOADING_FAILED;
        } else {
            return HEALTH_STATUS.DISCONNECTED;
        }
    }

    const getSoftwareStatus = ({swStatus, swType}) => {
        if (DEPLOYMENT_STATUS.SUCCESS.includes(swStatus)) {
            return DEPLOYMENT_TYPE.DEPLOYMENT.includes(swType) ? SW_STATUS.DEPLOYED : SW_STATUS.CLEAN;
        } else if (DEPLOYMENT_STATUS.IN_PROGRESS.includes(swStatus)) {
            return DEPLOYMENT_TYPE.DEPLOYMENT.includes(swType) ? SW_STATUS.DEPLOYMENT_IN_PROGRESS : SW_STATUS.RESET_IN_PROGRESS;
        } else if (DEPLOYMENT_STATUS.QUEUED.includes(swStatus)) {
            return SW_STATUS.QUEUED;
        } else if (swStatus === LOADING_FAILED) {
            return SW_STATUS.LOADING_FAILED;
        } else if (swStatus === LOADING_STRING) {
            return SW_STATUS.LOADING;
        } else if(swStatus === SW_STATUS.RESTARTED) {
            return SW_STATUS.RESTARTED
        } else if(swStatus === SW_STATUS.RESTART_IN_PROGRESS) {
            return SW_STATUS.RESTART_IN_PROGRESS
        }else {
            return SW_STATUS.ERROR;
        }
    }

    const renderRemark = (device, index) => {
        return (
            <Row>
                {(remark[index] && remark[index].close === true) && (remark[index].value === "" ?
                    <Text truncate="true"> {device.remark} </Text> :
                    <Text truncate="true"
                          value={remark[index].value}>{remark[index].value} </Text>)}
                {remark[index] && (remark[index].close === false) ?
                    (<Row>
                        <Input
                            onChange={(value) => handleInputChange(index, value)}
                            value={remark[index].value}
                            placeholder="Enter remark"
                            size="small"
                            autoFill="true"
                            focus="true"
                            resize="vertical"
                            onKeyDown={(event) => handleKeyDown(index, device, event)}
                            rows={1}/>
                        <Button
                            onClick={() => onClickConfirmRemark(index, device)}
                            size="small">
                            <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                        </Button>
                    </Row>) :
                    <Button type="link"
                            onClick={() => onClickEditRemark(index)}
                            size="small">
                        <Icon tokens={editTokens}/>
                    </Button>}
            </Row>
        )
    }

    const renderDeviceIp = (healthStatus, ip) => {
        return (
            <Text color={healthStatus === HEALTH_STATUS.DISCONNECTED.string ? "secondary" : "primary"}>
                {ip}
            </Text>
        )
    }

    const renderDeviceVLAN = (healthStatus, vlan) => {
        return <Text color={healthStatus === HEALTH_STATUS.DISCONNECTED.string ? "secondary" : "primary"}>
            {"VLAN " + vlan}
        </Text>
    }

    const checkPrimaryUseCase = (useCase, isPrimary) => {
        return ((useCase === SBL_ASSET_TYPE || useCase === SBLV2_ASSET_TYPE || useCase === IOT_AUTOMATION_ONLOGIC_ASSET_TYPE) && isPrimary === TRUE_VALUE && <Text type="b200">
            <div style={{color: BLUE_COLOR}}>{PRIMARY}</div>
        </Text>)
    }

    const renderDeviceMonitoring = (monitoringStatusColor, monitoringStatusId, monitoringStatusDefaultMessage) => {
        return (<b style={{color: monitoringStatusColor}}>
            <FormattedMessage id={monitoringStatusId} defaultMessage={monitoringStatusDefaultMessage}/>
        </b>)
    }

    const deleteThinClient = (device) => {
        dispatch({type: "DELETE_DEVICE_DATA", data: {dispatcher: dispatch, mac: device.mac}})
    }

    const renderTableRow = (device, index) => {
        const {string: healthStatus, color: healthColor} = getDeviceHealthStatus(device);
        const {string: swStatus, color: swColor} = getSoftwareStatus(device);
        const monitoring = checkDeviceMonitoringEnabled(device.startTime, device.endTime);
        const {monitoringStatusColor, monitoringStatusId, monitoringStatusDefaultMessage} = getMonitoringStatusDetails(monitoring);
        const isIOTOrMHEAutomationAsset = [SBLV2_ASSET_TYPE, AUTOMATION_ASSET_TYPE, IOT_AUTOMATION_ONLOGIC_ASSET_TYPE].includes(device.useCase);
        const isIOTAutomationAsset = [SBL_ASSET_TYPE, SBLV2_ASSET_TYPE, IOT_AUTOMATION_ONLOGIC_ASSET_TYPE].includes(device.useCase);

        const useCaseTextMap = {
            [SBL_ASSET_TYPE]: device.useCase.toUpperCase(),
            [SBLV2_ASSET_TYPE]: SBLV2_TEXT,
            [IOT_AUTOMATION_ONLOGIC_ASSET_TYPE]: SBLV3_TEXT,
        };

        const useCaseText = useCaseTextMap[device.useCase] || AUTOMATION_TEXT;

        return (
            <TableRow key={device.mac}
                      highlightOnHover={true}>
                <TableCell>
                    <Link target={"_blank"} rel={"noopener noreferrer"} type="secondary"
                          href={`${TAKA_CLIENT_LINK_PREFIX}/${getNodeId().toLowerCase()}/${getMacWithoutColon(device.mac)}`}>
                    <b> {device.mac} </b> <Icon tokens={exportToken}/>
                    </Link>
                    <br></br>
                    <ConditionalWrapping
                        condition={healthStatus === HEALTH_STATUS.DISCONNECTED.string}
                        wrapper={tooltipWrapper}
                        args={{
                            title: getLocalizedMessage({intl, stringId: "tooltip.disconnectedipvlan"}),
                            position: "top"
                        }}
                        child={renderDeviceIp(healthStatus, device.ip)}
                    />
                </TableCell>
                <TableCell>
                    <ConditionalWrapping
                        condition={healthStatus === HEALTH_STATUS.DISCONNECTED.string}
                        wrapper={tooltipWrapper}
                        args={{
                            title: getLocalizedMessage({intl, stringId: "tooltip.disconnectedipvlan"}),
                            position: "top"
                        }}
                        child={renderDeviceVLAN(healthStatus, device.vlan)}
                    />
                </TableCell>
                <TableCell>
                    {useCaseText}
                    {<ConditionalPlaceholder
                        placeholder={showStatusLoader(device.mac, 'usecaseStatusLoader')}
                        args={{
                            tooltipTitle: getLocalizedMessage({intl, stringId: 'tooltip.statusLoading'}),
                            tooltipPosition: "start",
                            loaderSize: "small"
                        }}
                        view={checkPrimaryUseCase(device.useCase, device.primary)}
                    />}
                </TableCell>
                <TableCell>
                    <p style={{color: healthColor}}>
                        <b>{healthStatus}</b>
                    </p>
                </TableCell>
                <TableCell>
                    <p style={{color: swColor}}>
                        <b>{<ConditionalPlaceholder
                            placeholder={showStatusLoader(device.mac, 'softwareStatusLoader')}
                            args={{
                                tooltipTitle: getLocalizedMessage({intl, stringId: 'tooltip.statusLoading'}),
                                tooltipPosition: "start",
                                loaderSize: "medium"
                            }}
                            view={swStatus}
                        />}</b>
                    </p>
                </TableCell>
                <TableCell>
                    {<ConditionalPlaceholder
                        placeholder={showStatusLoader(device.mac, 'monitoringStatusLoader')}
                        args={{
                            tooltipTitle: getLocalizedMessage({intl, stringId: 'tooltip.monitoringStatusLoading'}),
                            tooltipPosition: "start",
                            loaderSize: "medium"
                        }}
                        view={renderDeviceMonitoring(monitoringStatusColor, monitoringStatusId, monitoringStatusDefaultMessage)}
                    />}
                </TableCell>
                <TableCell width="400px">
                    {renderRemark(device, index)}
                </TableCell>
                <TableCell>
                    <Text type="b300">
                        <Button ref={el => actionButtonRefs.current[index] = el}
                                type="icon"
                                size="medium"
                                onClick={() => onClickActionsButton(index)}
                                aria-controls="my-menu"
                                aria-haspopup="menu"
                                aria-expanded="false">
                            ...
                        </Button>
                        <Menu anchorNode={actionButtonRefs.current[index]}
                              id="my-menu"
                              open={openActionsMenu[index] ? openActionsMenu[index] : false}
                              position="left"
                              onClose={() => onCloseActions(index)}>
                            { isIOTOrMHEAutomationAsset &&
                                <MenuItem onClick={() => onClickRestartApplication(device.mac, device.useCase)}>
                                    <FormattedMessage id="actions.restart" defaultMessage="Restart Application"/>
                                </MenuItem>}
                            {(monitoring.isMonitoringEnabled) ?
                                <MenuItem onClick={() => onClickDisableMonitoring(device.mac)}>
                                    <FormattedMessage id="actions.monitoring_disable"
                                                      defaultMessage="Disable Monitoring"/>
                                </MenuItem> : <MenuItem
                                    onClick={() => onClickEnableMonitoring(device.startTime, device.reason, device.mac)}>
                                    <FormattedMessage id="actions.monitoring_enable"
                                                      defaultMessage="Enable Monitoring"/>
                                </MenuItem>}
                            { isIOTAutomationAsset && device.primary === FALSE_VALUE &&
                                <MenuItem onClick={() => onClickToggleUsecase(device)}>
                                    <FormattedMessage id="actions.primary"
                                                      defaultMessage="Make Primary Use Case"/>
                                </MenuItem>}
                            {(device.useCase !== SBL_ASSET_TYPE)  &&
                                <MenuItem onClick={() => onClickChangeUsecase(device)}>
                                    <FormattedMessage id="actions.usecase"
                                                      defaultMessage="Change Thin Client use case"/>
                                </MenuItem>}
                            {checkHealthStatusForDeletion(healthStatus) &&
                                <MenuItem onClick={() => deleteThinClient(device)}>
                                    <FormattedMessage id="device.delete" defaultMessage="Delete"/>
                                </MenuItem>
                            }
                        </Menu>
                        {openAddModal && <DisableMonitoringModal mac={mac} state={openAddModal}
                                                                 onStateChange={setOpenAddModal}
                                                                 context={ThinClientOverviewContext}
                                                                 reducer={'ADD_DEVICE_DATA'}/>}
                    </Text>
                </TableCell>
            </TableRow>
        )
    }

    if (viewModel.loadingOverview) {
        return (<LoaderView/>)
    } else {
        return (
            <Row widths="100%"
                 alignmentVertical="top"
                 spacingInset="none none large none">
                <Column>
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <RefreshTimer deps={[viewModel.timestamp]}/>
                        <Box></Box>
                        <Tooltip position="top" title={intl.formatMessage({
                            id: 'tooltip.scrolltobottom',
                            defaultMessage: 'Scroll to bottom!'
                        })}>
                            <Button onClick={scrollToBottom}
                                    type="secondary"
                                    size="small">
                                <Icon tokens={chevronDownLargeTokens}/>
                            </Button>
                        </Tooltip>
                    </Row>
                    {/* <Banner/> */}
                    {sortedDeviceList.length === 0 ?
                        <Alert
                            type="informational"
                            size="small"
                        >
                            <FormattedMessage id="alert.device"
                                              defaultMessage="No device present for this station."/>
                        </Alert> :
                        <Table
                            headerRows={1}
                            spacing="small"
                            sortColumn={viewModel.sortPref.column}
                            sortDirection={viewModel.sortPref.direction}
                            onSort={onSort}
                            showDividers={true}
                            showStripes={true}>
                            <TableRow highlightOnHover={false}>
                                <TableCell sortColumn="mac">
                                    <FormattedMessage id="device.mac_ip" defaultMessage="MAC/IP"/>
                                </TableCell>
                                <TableCell sortColumn="vlan">
                                    <FormattedMessage id="device.vlan" defaultMessage="VLAN"/>
                                </TableCell>
                                <TableCell sortColumn="useCase">
                                    <FormattedMessage id="device.useCase" defaultMessage="Use Case"/>
                                </TableCell>
                                <TableCell sortColumn="connection">
                                    <Tooltip position="top" title={intl.formatMessage({
                                        id: 'status.tooltip',
                                        defaultMessage: 'Healthy: Device is working correctly. ' +
                                            'Disconnected: Device is not properly connected to both internet and local network.' +
                                            'Loading failed: Failed to fetch connection status of the device, something may be wrong.'
                                    })}>
                                        <FormattedMessage id="device.status" defaultMessage="Status"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="swstatus">
                                    <FormattedMessage id="device.swstatus" defaultMessage="Software Status"/>
                                </TableCell>
                                <TableCell sortColumn="monitoring">
                                    <FormattedMessage id="device.monitoring" defaultMessage="Monitoring Status"/>
                                </TableCell>
                                <TableCell sortColumn="remark">
                                    <FormattedMessage id="device.remark" defaultMessage="Remark"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="device.action" defaultMessage="Action"/>
                                </TableCell>
                            </TableRow>
                            {sortedDeviceList.map((device, index) => renderTableRow(device, index))}
                        </Table>}
                    <Row width="100%" widths={["fill", "100"]}>
                        <Box></Box>
                        <DeleteSingleDeviceModal macAddressArray={viewModel.macAddressArray} dispatch={dispatch}/>
                    </Row>
                    <Row width="100%" widths={["fill", "100"]}>
                        <Box></Box>
                        <ChangeDeviceUseCaseModal open={openTCUseCaseChangeModal} setOpen={setOpenTCUseCaseChangeModal}
                                                  selectedDevice={selected} setSelectedDevice={setSelected}
                                                  dispatch={dispatch}/>
                    </Row>
                    <div ref={tableEndRef}/>
                </Column>
            </Row>
        );
    }
}

export default injectIntl(ThinClientOverview)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/ThinClientOverview.js